module.exports = __webpack_public_path__ + "static/media/59.a9944179.jpg";